/**
 * Zustand store for managing building selection state.
 */

import { create } from 'zustand';

interface BuildingSelectionState {
  selectedBuildingId: string | null;
  setSelectedBuilding: (buildingId: string | null) => void;
  clearSelection: () => void;
}

export const useBuildingSelectionStore = create<BuildingSelectionState>((set) => ({
  selectedBuildingId: null,
  setSelectedBuilding: (buildingId: string | null) =>
    set({ selectedBuildingId: buildingId }),
  clearSelection: () => set({ selectedBuildingId: null }),
}));

